module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/vacunacion-90d22bd256f3d09fa10b602da14d810c.jpg";